/* eslint-disable @typescript-eslint/no-empty-interface */
const config = { domain: 'Fundraising', subdomain: 'Payouts' }

interface Clicked {}

interface FailedPayoutBanner {
  userId: number
  nonprofitOrgId: number
  url: string
}

export const payouts = {
  Clicked: {
    Clicked: (param: Clicked) => param,
    config,
  },
  Failed_Payout_Banner_Clicked: {
    Failed_Payout_Banner_Clicked: (param: FailedPayoutBanner) => param,
    config,
  },
  Failed_Payout_Banner_Dismissed: {
    Failed_Payout_Banner_Dismissed: (param: FailedPayoutBanner) => param,
    config,
  },
}
